module.exports = __webpack_public_path__ + "static/media/tsunami.38f76e56.jpg";